// next-seo.config.js

const SEO = {
  title: "PRO SLV | Expert Audio & Visual Production ServicesPRO SLV | Professional Audiovisual Services – Sound, Lighting & Video",
  description: "PRO SLV delivers expert audiovisual services including sound, lighting, video production & event AV rentals. Perfect for weddings, corporate & live events.",
  openGraph: {
    type: "website",
    locale: "en_US",
    url: "https://www.proslv.com.ph",
    site_name: "PROSLV",
    title: "PRO SLV | Professional Audiovisual Services – Sound, Lighting & Video",
    description: "PRO SLV delivers expert audiovisual services including sound, lighting, video production & event AV rentals. Perfect for weddings, corporate & live events.",
    images: [
      {
        url: "/images/og_image.png",
        width: 1200,
        height: 630,
        alt: "PROSLV",
        type: "image/jpeg",
      },
    ],
  },
};

export default SEO;
